import Link from "next/link";
import { Mail, Instagram, Send, Rss } from "lucide-react";
import BrandMark from "@/components/BrandMark";

export default function BlogFooter() {
  return (
    <footer className="border-t border-border bg-muted/30">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-14">
        <div className="grid gap-8 lg:grid-cols-[1.5fr_1fr_1fr_1.5fr]">
          <div>
            <div className="mb-3 flex items-center gap-2.5">
              <BrandMark size={36} />
              <span className="text-base font-black text-foreground">بلاگ ترندی اسمارت</span>
            </div>
            <p className="text-sm leading-relaxed text-muted-foreground">
              راهنمای جامع اتوماسیون، هوش مصنوعی و مدیریت تعاملات دیجیتال — به زبان فارسی، برای
              کسب‌وکارهای ایرانی.
            </p>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-black text-foreground">دسترسی سریع</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link href="/blog" className="hover:text-primary-main">
                  همه مقالات
                </Link>
              </li>
              <li>
                <Link href="/" className="hover:text-primary-main">
                  سایت اصلی
                </Link>
              </li>
              <li>
                <Link href="/changelog" className="hover:text-primary-main">
                  تغییرات نسخه
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-black text-foreground">قانونی</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link href="/terms" className="hover:text-primary-main">
                  قوانین
                </Link>
              </li>
              <li>
                <Link href="/privacy" className="hover:text-primary-main">
                  حریم خصوصی
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 text-sm font-black text-foreground">عضویت در خبرنامه</h4>
            <p className="mb-3 text-xs text-muted-foreground">بهترین مقالات هفته در ایمیل شما.</p>
            <form className="flex gap-2">
              <input
                type="email"
                placeholder="ایمیل شما"
                className="h-10 flex-1 rounded-lg border border-border bg-background px-3 text-xs outline-none focus:border-primary-main"
              />
              <button
                type="button"
                className="inline-flex h-10 items-center justify-center gap-1 rounded-lg bg-primary-main px-4 text-xs font-black text-white hover:bg-primary-400"
              >
                <Mail size={12} />
                عضویت
              </button>
            </form>
            <div className="mt-4 flex items-center gap-2">
              {[Instagram, Send, Rss].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="flex h-9 w-9 items-center justify-center rounded-lg border border-border text-muted-foreground transition-colors hover:border-primary-main hover:text-primary-main"
                >
                  <Icon size={14} />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-10 border-t border-border pt-6 text-center text-xs text-muted-foreground">
          © {new Date().toLocaleDateString("fa-IR", { year: "numeric" })} ترندی اسمارت — تمام حقوق
          محفوظ است.
        </div>
      </div>
    </footer>
  );
}
